import $ from "jquery";

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

$(".js-calendar-source").each(function () {
  const calendar = "#" + $(this).data("calendar");
  const cellPadding = 4;

  let themeNames = [];
  let themeIds = [];
  let themeColours = [];

  // Obtain all available themes
  $(this)
    .find(".js-calendar-event")
    .each(function () {
      themeIds.push($(this).data("theme-id"));
      themeNames.push($(this).data("theme"));
      themeColours.push($(this).data("theme-colour"));
    });

  // Filter out duplicate themes
  themeIds = themeIds.filter(onlyUnique);
  themeNames = themeNames.filter(onlyUnique);
  themeColours = themeColours.filter(onlyUnique);

  // Build empty calendar with themes and colours
  $.each(themeIds, (i) => {
    const row = $("<div/>")
      .addClass("calendar-panel__row")
      .attr("style", "--themeColour: #" + themeColours[i]);

    row.append(
      $("<div/>")
        .addClass("calendar-panel__cell calendar-panel__cell--heading")
        .text(themeNames[i]),
    );

    for (let c = 0; c < 12; c++) {
      row.append(
        $("<div/>")
          .addClass("calendar-panel__cell")
          .attr("data-theme-id", themeIds[i])
          .attr("data-month", c + 1),
      );
    }

    row.appendTo(calendar);
  });

  // Populate empty calendar & list with events
  $(this)
    .find(".js-calendar-event")
    .each(function () {
      const eventThemeId = $(this).data("theme-id");
      const eventFrom = $(this).data("month-from");
      const eventTo = $(this).data("month-to");
      const eventRange = parseInt(eventTo, 10) - parseInt(eventFrom, 10) + 1;
      const eventContent = $(this).find(".calendar-panel__event-inner");
      const dateFromCell = $(
        ".calendar-panel__cell[data-theme-id=" +
          eventThemeId +
          "][data-month=" +
          eventFrom +
          "]",
      );

      if (eventRange > 1) {
        eventContent
          .attr(
            "style",
            "width: calc(" +
              eventRange +
              "00% + " +
              (eventRange - 1) * cellPadding +
              "px);",
          )
          .attr("data-span", eventRange);
      }

      // Append to calendar
      eventContent.clone().appendTo(dateFromCell);

      // Append to list
      for (let i = eventFrom; i <= eventTo; i++) {
        eventContent
          .clone()
          .appendTo(
            ".calendar-panel__list-item[data-month=" +
              i +
              "] .calendar-panel__list-panel-inner",
          );
        $(".calendar-panel__list-item[data-month=" + i + "]").removeClass(
          "calendar-panel__list-item--no-events",
        );
      }
    });

  // Set positioning of events that span multiple months
  $(
    ".calendar-panel__cell:not(.calendar-panel__cell--heading):not(.calendar-panel__cell--empty)",
  ).each(function () {
    let prevMonthHeight = 0;
    const eventSpan = $(this).children("[data-span]").data("span");

    $(this)
      .children()
      .each(function () {
        prevMonthHeight = prevMonthHeight + $(this).outerHeight(true);
      });

    if (prevMonthHeight > 0) {
      $(this)
        .nextAll("*:lt(" + (eventSpan - 1) + ")")
        .css("padding-top", prevMonthHeight + 4);
    }
  });
});

// Grid (calendar)/list view toggle
$(window).on("load", () => {
  $(".js-calendar-grid-view").removeClass("inactive").hide();

  if ($(".js-calendar-toggle").is(":checked")) {
    $(".js-calendar-grid-view").show();
    $(".js-calendar-list-view").hide();
  }
});

$(".js-calendar-toggle").on("change", () => {
  $(".js-calendar-grid-view").toggle();
  $(".js-calendar-list-view").toggle();
});

// Horizontal scrolling on calendar view
const calendars = document.querySelectorAll(".js-scrollable-calendar");

let isDown = false;
let startX;
let scrollLeft;

calendars.forEach((slider) => {
  if (slider instanceof HTMLElement) {
    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mousemove", (e) => {
      if (!isDown) {
        return;
      }
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = x - startX;
      slider.scrollLeft = scrollLeft - walk;
    });
  }
});
